// src/redux/thunks/registerBusinessUser.js

import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';

export const registerBusinessUser = createAsyncThunk(
  'business/register',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/business/register`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return response.data; // {status, message, ...}
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { status: 'error', message: 'Registration failed' }
      );
    }
  }
);

